import { useMutation, useQuery } from "react-query";
import { NameAndId, ServerError } from "../../data";
import { useAxios } from "../../hooks";

export const useGetTemplateCategories = () => {
  const axios = useAxios();
  return useQuery<NameAndId[], ServerError>({
    queryKey: ["template-categories"],
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    retry: false,

    queryFn: () => axios.get("/templates/api/categories", {}),
  });
};
export const useGetTemplates = () => {
  const axios = useAxios();
  return useQuery<TemplateDataHouse, ServerError>({
    queryKey: ["templates"],
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchInterval: 0,
    retry: false,
    queryFn: () => axios.get("/templates/api", {}),
  });
};

export const useGetTemplateById = () => {
  var axios = useAxios(false);
  return useMutation<TemplateData, ServerError, any>((templateId) => {
    return axios.get(`/templates/api/${templateId}`, templateId);
  });
};
export const useDeleteTemplate = () => {
  var axios = useAxios();
  return useMutation<TemplateData, ServerError, any>((templateId) => {
    return axios.delete(`/templates/api/${templateId}`, templateId);
  });
};
export const useCreateTemplate = () => {
  var axios = useAxios();
  return useMutation<TemplateData, ServerError, TemplateModel>((model) => {
    return axios.post(`/templates/api/create`, model, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  });
};
export const useSaveTemplate = () => {
  var axios = useAxios();
  return useMutation<TemplateData, ServerError, TemplateModel>((model) => {
    return axios.post(`/templates/api/save`, model, {
      // headers: { "Content-Type": "multipart/form-data" },
    });
  });
};
export const useCreateCategory = () => {
  var axios = useAxios();
  return useMutation<TemplateData, ServerError, CreateCategoryModel>((model) => {
    return axios.post(`/templates/api/categories`, model);
  });
};

export interface TemplateDataHouse {
  defaultTemplates: TemplateData[];
  savedTemplates: TemplateData[];
  defaultCategories: NameAndId[];
  savedCategories: NameAndId[];
}
export interface TemplateData {
  imageUrl: string;
  name: string;
  isActive: boolean;
  categoryId: number;
  categoryName: string;
  id: any;
  isClient: boolean;
  isLegacy: boolean;
  body: string;
}

export interface TemplateModel {
  categoryId?: number;
  name?: string;
  message1?: string;
  message2?: string;
  templateId?: number;
  logUrl?: string;
  topImage?: string;
  screenshot: string;
}

export interface CreateCategoryModel {
  name: string;
}
